import { render, staticRenderFns } from "./RememberPasswordPage.vue?vue&type=template&id=ae8087cc"
import script from "./RememberPasswordPage.js?vue&type=script&lang=js&external"
export * from "./RememberPasswordPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports